import React, { Component } from 'react';
import { ApiDomainUrl, GetCookie } from './utils/Common';

function decodeJwtPayload(token) {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

function isSessionExpired(token) {
  try {
    const payload = decodeJwtPayload(token);
    return !payload?.exp || payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export class AuthorizeJob extends Component {
  static displayName = AuthorizeJob.name;

  constructor(props) {
    super(props);
    this.state = { status: 'loading' }; // loading | success | alreadyUsed | error
  }

  async componentDidMount() {
    const token = window.location.hash.replace(/^#/, '') || null;

    if (!token) {
      this.setState({ status: 'error' });
      return;
    }

    try {
      const userCookie = GetCookie('user');
      const user = userCookie ? JSON.parse(userCookie) : null;

      if (user?.token && !isSessionExpired(user.token)) {
        const payload = decodeJwtPayload(token);
        const tokenType = payload?.type;

        if (tokenType === 'multi_job_auth') {
          const jobIds = (payload?.jobids || '').split(',').map((s) => s.trim()).filter(Boolean);
          if (jobIds.length) {
            const results = await Promise.all(
              jobIds.map((jobId) =>
                fetch(`${ApiDomainUrl()}/repauthorize`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Authorization: user.token },
                  body: JSON.stringify({ JobId: jobId }),
                }).then((r) => r.status)
              )
            );
            const anyError = results.some((s) => s !== 200 && s !== 409);
            const allAlreadyUsed = results.every((s) => s === 409);
            if (anyError) this.setState({ status: 'error' });
            else if (allAlreadyUsed) this.setState({ status: 'alreadyUsed' });
            else this.setState({ status: 'success' });
            return;
          }
        } else {
          const jobId = payload?.jobid;
          if (jobId) {
            const response = await fetch(`${ApiDomainUrl()}/repauthorize`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Authorization: user.token },
              body: JSON.stringify({ JobId: jobId }),
            });
            if (response.ok) this.setState({ status: 'success' });
            else if (response.status === 409) this.setState({ status: 'alreadyUsed' });
            else this.setState({ status: 'error' });
            return;
          }
        }
      }

      // Fall back to public token endpoint for unauthenticated reps
      const response = await fetch(`${ApiDomainUrl()}/authorize-job`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      if (response.ok) this.setState({ status: 'success' });
      else if (response.status === 409) this.setState({ status: 'alreadyUsed' });
      else this.setState({ status: 'error' });
    } catch {
      this.setState({ status: 'error' });
    }
  }

  render() {
    const { status } = this.state;

    const containerStyle = {
      fontFamily: 'sans-serif',
      textAlign: 'center',
      padding: '60px 20px',
    };

    if (status === 'loading') {
      return (
        <div style={containerStyle}>
          <p style={{ fontSize: '1.1rem', color: '#555' }}>Processing authorization…</p>
        </div>
      );
    }

    if (status === 'success') {
      return (
        <div style={containerStyle}>
          <div style={{ fontSize: '3rem', color: '#28a745' }}>✓</div>
          <h2 style={{ color: '#28a745' }}>Service Authorized</h2>
          <p style={{ color: '#555' }}>Thank you for authorizing the service. You may close this window.</p>
        </div>
      );
    }

    if (status === 'alreadyUsed') {
      return (
        <div style={containerStyle}>
          <div style={{ fontSize: '3rem', color: '#f0ad4e' }}>!</div>
          <h2 style={{ color: '#f0ad4e' }}>Already Authorized</h2>
          <p style={{ color: '#555' }}>This link has already been used. The service was previously authorized.</p>
        </div>
      );
    }

    return (
      <div style={containerStyle}>
        <div style={{ fontSize: '3rem', color: '#dc3545' }}>✗</div>
        <h2 style={{ color: '#dc3545' }}>Invalid or Expired Link</h2>
        <p style={{ color: '#555' }}>This authorization link is no longer valid. Please contact your representative.</p>
      </div>
    );
  }
}
